module.exports = __webpack_public_path__ + "static/media/plan-507+508-desktop-tc.4054c550.png";